'use client'

import useExchangeRate from '@/utils/hooks/useExchangeRate'
import { offerUsd } from '@/utils/offer-currency'
import styles from './offer-usd.module.css'

/** Display only. All offer pricing and signing remain denominated in sats. */
export default function OfferUsd({
	sats,
	block = false,
	parentheses = false,
	compact = false,
	showApproximation = true
}: {
	sats?: number | null
	block?: boolean
	parentheses?: boolean
	/** Drop the trailing "USD" where the row is tight (the dialog's figure chips). */
	compact?: boolean
	showApproximation?: boolean
}) {
	const { exchangeRate } = useExchangeRate()
	const formatted = offerUsd(sats, exchangeRate)
	const full = showApproximation ? formatted : formatted?.replace(/^≈\s*/, '')
	const value = full && compact ? full.replace(/\s*USD$/, '') : full
	if (!value) return null
	return (
		<small
			className={block ? styles.block : styles.usd}
			title="Estimated USD value at the current BTC exchange rate"
		>
			{parentheses ? `(${value})` : value}
		</small>
	)
}
